import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { createStyles, ListItemText, Theme, withStyles, WithStyles } from '@material-ui/core';
import { graphql } from 'babel-plugin-relay/macro';

import { Checkbox, ListItem, ListItemProps, Typography } from 'components/v2';

import { ListItemPatientContact_PatientContact$key } from './__generated__/ListItemPatientContact_PatientContact.graphql';
import IconPatientContactType from './IconPatientContactType';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    iconWrapper: {
      marginRight: unit,
      marginBottom: 1,
    },
    listItemText: {
      display: 'flex',
      alignItems: 'center',
    },
    listItemTextActive: {
      marginLeft: 0.5,
    },
  });

const messages = defineMessages({
  active: {
    id: 'deprecated.fragments.ListItemPatientContact.active',
    defaultMessage: 'Active',
  },
});

export interface ListItemPatientContactProps
  extends Omit<ListItemProps, 'classes' | 'fragmentRef'>,
    WithStyles<typeof styles> {
  fragmentRef: ListItemPatientContact_PatientContact$key;
  checked?: boolean;
  onCheck: (event: any, checked: boolean) => void;
}

const ListItemPatientContact: React.FC<ListItemPatientContactProps> = ({
  classes,
  fragmentRef,
  onCheck,
  checked,
  ...rest
}) => {
  const patientContact = useFragment<ListItemPatientContact_PatientContact$key>(
    graphql`
      fragment ListItemPatientContact_PatientContact on PatientContact {
        __typename
        active
        type
        value
        ...IconPatientContactType_PatientContact
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();

  return (
    <ListItem onClick={(event) => onCheck(event, !checked)} {...rest}>
      <ListItemText
        className={classes.listItemText}
        disableTypography
        primary={
          <>
            <Checkbox color="primary" size="small" checked={checked} />
            <div className={classes.iconWrapper}>
              <IconPatientContactType fragmentRef={patientContact} color="supportSlate" fontSize="small" />
            </div>
            <Typography variant="body1" color="primary" noWrap>
              {patientContact.value}
            </Typography>
            {patientContact.active && (
              <div className={classes.listItemTextActive}>
                <Typography variant="body1" color="primary" inline>
                  ({formatMessage(messages.active)})
                </Typography>
              </div>
            )}
          </>
        }
      />
    </ListItem>
  );
};

export default withStyles(styles)(ListItemPatientContact);
